export default __webpack_public_path__ + "static/media/voxodeus_logo_-_tp_stacked.c3f1ea90.png";